import React, { useEffect } from 'react';
import { useTranslation } from 'next-i18next';
import { c as classnames } from './index-2586sEvh.js';
import { T as TabNames, b as getTabsLabel } from './helper-qZTqmbEO.js';

const ItemTabs = ({ items, setActiveTab, activeTab }) => {
    const { t: tLabel } = useTranslation('', { keyPrefix: '$common.$labels' });
    const focusTab = (toTabName) => {
        setActiveTab(toTabName);
        document.getElementById(`tab-${toTabName + 1}`).focus();
    };
    const onKeyDown = (e, tabName) => {
        const index = items.indexOf(items.find(item => item.type === tabName));
        if (e.key === 'Enter') {
            setActiveTab(tabName);
        }
        if (e.key === 'ArrowRight') {
            const nextIndex = items.length - 1 === index ? 0 : index + 1;
            const toTabName = items[nextIndex].type;
            focusTab(toTabName);
        }
        if (e.key === 'ArrowLeft') {
            const prevIndex = index === 0 ? items.length - 1 : index - 1;
            const toTabName = items[prevIndex].type;
            focusTab(toTabName);
        }
        if (e.key === 'Home') {
            e.preventDefault();
            focusTab(items[0].type);
        }
        if (e.key === 'End') {
            e.preventDefault();
            focusTab(items[items.length - 1].type);
        }
    };
    useEffect(() => {
        if (!activeTab) {
            setActiveTab(TabNames.Description);
        }
    }, []);
    const activeTabPanel = items.filter((item) => item.type === activeTab);
    return (React.createElement("div", { className: "item-copy tabs clear" },
        React.createElement("div", { className: "tab-links", role: "tablist" }, items.map((item) => (React.createElement("div", { key: item.type, role: "tab", id: `tab-${item.type + 1}`, tabIndex: activeTab === item.type ? 0 : -1, className: classnames('tab-switcher-item', {
                active: activeTab === item.type,
            }), onKeyDown: e => onKeyDown(e, item.type), onClick: () => setActiveTab(item.type), "aria-selected": activeTab === item.type, "aria-controls": `tabpanel-${item.type + 1}` },
            React.createElement("span", null, tLabel(getTabsLabel(item.type))))))),
        React.createElement("div", { className: `tab-switcher-content tab-${activeTab + 1}` }, activeTabPanel.map((item) => (React.createElement("div", { key: item.type, className: getTabsLabel(item.type), dangerouslySetInnerHTML: {
                __html: item.html,
            }, id: `tabpanel-${item.type + 1}`, "aria-labelledby": `tab-${item.type + 1}`, role: "tabpanel", tabIndex: 0 }))))));
};

export { ItemTabs as I };
//# sourceMappingURL=ItemTabs-PRQx9xWO.js.map
